import { LssCheckout } from "@/components/Funnel/LssCheckout/LssCheckout";

import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { InputsContainer } from "../components/inputs-container";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";

import type { StepProps } from "./step.types";

export default function LssCheckoutStep({ handlers, experiments }: StepProps) {
  return (
    <>
      <StepContainer className="bg-surface">
        <StepContent>
          <BackButton />
          <InputsContainer className="mt-10 max-w-[580px]">
            <LssCheckout handlers={handlers} experiments={experiments} />
          </InputsContainer>
        </StepContent>
      </StepContainer>
      <Footer />
    </>
  );
}
